import { SET_CUSTOMER_NAME } from "./home/action";
import { FORGET_PASSWORD, HIDE_PRIVACY_POLICY_MODAL, HIDE_TERM_AND_CONDITION_MODAL, LOGIN, loginComplete, LOGIN_COMPLETE, logOut, LOG_OUT, LOG_OUT_COMPLETE, REGISTER_DRIVER, REGISTER_DRIVER_COMPLETE, RESET_PASSWORD, SHOW_PRIVACY_POLICY_MODAL, SHOW_TERM_AND_CONDITION_MODAL } from "./login/action"
import { getConfig } from "../services/environment";
import { HIDE_ERROR_MODAL, STOP_LOADING, SHOW_ERROR_MODAL, START_LOADING, showErrorMessage } from "./layout/action";
import { isAccessTokenValid, isRefreshTokenValid } from "./SoapUtilities";
import { requestApi } from "../api/Api";
import * as QueryParams from 'query-string';


const byPassAction = ["persist/REHYDRATE", SET_CUSTOMER_NAME, "persist/PERSIST",
  LOGIN, LOGIN_COMPLETE, LOG_OUT_COMPLETE, LOG_OUT, FORGET_PASSWORD,
  SHOW_TERM_AND_CONDITION_MODAL, HIDE_TERM_AND_CONDITION_MODAL,
  SHOW_PRIVACY_POLICY_MODAL, HIDE_PRIVACY_POLICY_MODAL,
  REGISTER_DRIVER, START_LOADING, STOP_LOADING, REGISTER_DRIVER_COMPLETE,
  RESET_PASSWORD, SHOW_ERROR_MODAL, HIDE_ERROR_MODAL,

]


async function fetchRefreshToken(dispatch, state) {
  const { refresh_token } = state;
  try {
    let data = {
      client_id: getConfig.clientId,
      client_secret: getConfig.clientSecret,
      grant_type: 'refresh_token',
      refresh_token: refresh_token,
    }
    let optionConfig = {
      data: QueryParams.stringify(data),
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
      method: 'POST',
      url: '/auth/realms/rpe2g/protocol/openid-connect/token',
    }
    let response = await requestApi(optionConfig);
    dispatch(loginComplete({
      ...response.data,
      timestamp: Date.now()
    }))
    return response.data
  } catch (error) {
    dispatch(showErrorMessage({ error: error, title: "Login Failed" }))
    dispatch(logOut())
  }
}





export function needsTokenRefresh(loginState) {
  return !isAccessTokenValid(loginState) && isRefreshTokenValid(loginState);
}

export const refreshTokenMiddleware = store => next => action => {
  const { loginState } = store.getState();
  const { dispatch } = store;
  if ([...byPassAction].indexOf(action.type) !== -1) {
    next(action)
  } else {
    if (needsTokenRefresh(loginState)) {
      return fetchRefreshToken(dispatch, loginState).then(() => {
        next(action)
      });
    } else {
      next(action);
    }
  }
  return;
}



// export const refreshTokenMiddleware=({dispatch,getState})=>{
//   const {loginState}=getState()
//   // const loginState=state.loginState
//   return (next)=>{
//       return (action)=>{
//           Config()
//           if([...byPassAction].indexOf(action.type)!==-1){
//             next(action)
//           }else{
//             if(needsTokenRefresh(loginState)){ 

//             }else{
//               // next(action)
//             }
//             // next(action)
//           }
//       }
//   }
// }